module.exports = __webpack_public_path__ + "img/hollow-green-tick.29e84a78.svg";